const searchIndex = new WeakMap();
const containerFilters = new WeakMap();

const refilterAll = () => {
    document
        .querySelectorAll('[data-controller="card-filter"]')
        .forEach(container => containerFilters.get(container)?.())
    ;
};

document.addEventListener('selectoptionschanged', refilterAll);
document.addEventListener('screenshotmodeenabled', refilterAll);

export const initCardSearch = container => {
    const textFilter = container.querySelector('input[type="search"]');
    const selectFilters = Array.from(container.querySelectorAll('select'));
    const checkboxFilters = Array.from(container.querySelectorAll('input[type="checkbox"]'));
    const cards = container.querySelectorAll(container.dataset.cardSelector);
    const countElement = container.querySelector('[data-card-count]');

    const allCountText = countedCards => {
        const activeCount = countedCards.filter(card => card.matches('.active')).length;

        return activeCount > 0
            ? countElement.dataset.countAllActive.replace('%s', countedCards.length).replace('%s', activeCount)
            : countElement.dataset.countAll.replace('%s', countedCards.length)
        ;
    };

    const updateCount = (visibleCount, countedCards) => {
        if (!countElement) {
            return;
        }

        if (visibleCount === 0) {
            countElement.textContent = countElement.dataset.countNone;

            return;
        }

        countElement.textContent = visibleCount === countedCards.length
            ? allCountText(countedCards)
            : countElement.dataset.countFiltered.replace('%s', visibleCount).replace('%s', countedCards.length);
    };

    const updateCheckboxCounts = countedCards => {
        checkboxFilters.forEach(checkbox => {
            const checkboxCountElement = container.querySelector(`[data-checkbox-count="${checkbox.id}"]`);

            if (!checkboxCountElement) {
                return;
            }

            const matchingCount = countedCards
                .filter(card => searchIndex.get(card).booleanFilters[checkbox.id] === true)
                .length
            ;

            if (matchingCount === 0) {
                checkbox.checked = false;
            }

            checkbox.parentElement.classList.toggle('hidden', matchingCount === 0);
            checkboxCountElement.textContent = matchingCount === 1
                ? checkboxCountElement.dataset.countOne
                : checkboxCountElement.dataset.countMany.replace('%s', matchingCount)
            ;
        });
    };

    cards.forEach(card => {
        const searchableText = [
            ...Array.from(card.querySelectorAll(container.dataset.matchSelectors)).map(match => match.textContent || ''),
            card.dataset.searchTerms || '',
        ]
            .join(' ')
            .toLowerCase()
        ;

        const filterLists = {};
        selectFilters.forEach(select => {
            const listTarget = select.id;
            const listDataSelector = 'has' + listTarget.charAt(0).toUpperCase() + listTarget.slice(1);

            if (listDataSelector in card.dataset) {
                filterLists[listTarget] = card.dataset[listDataSelector].split(' ');
            }
        });

        const booleanFilters = {};
        checkboxFilters.forEach(checkbox => {
            const target = checkbox.id;
            const dataSelector = 'is' + target.charAt(0).toUpperCase() + target.slice(1);

            if (dataSelector in card.dataset) {
                booleanFilters[target] = card.dataset[dataSelector] === '1';
            }
        });

        searchIndex.set(card, {
            text: searchableText,
            filterLists: filterLists,
            booleanFilters: booleanFilters,
        });
    });

    const filterCards = () => {
        const searchTerm = (textFilter.value || '').trim().toLowerCase();

        const activeSelectFilters = selectFilters.map(select => {
            const values = Array.from(select.selectedOptions)
                .map(option => option.value)
                .filter(value => value !== '');

            return {
                target: select.id,
                values: values
            };
        }).filter(filter => filter.values.length > 0);

        cards.forEach(card => {
            card.style.display = '';
        });

        const countedCards = Array.from(cards).filter(card => getComputedStyle(card).display !== 'none');
        updateCheckboxCounts(countedCards);

        const activeCheckboxes = checkboxFilters.filter(cb => cb.checked);
        let visibleCount = 0;

        countedCards.forEach(card => {
            const cardIndex = searchIndex.get(card);
            const textMatches = searchTerm.length === 0 || cardIndex.text.includes(searchTerm);

            const selectsFiltersMatch = activeSelectFilters.every(filter => {

                const cardList = cardIndex.filterLists[filter.target] || [];

                return filter.values.every(value => cardList.includes(value));
            });

            const checkboxesMatch = activeCheckboxes.every(cb => {
                return cardIndex.booleanFilters[cb.id] === true;
            });

            const isVisible = textMatches && selectsFiltersMatch && checkboxesMatch;
            visibleCount += isVisible ? 1 : 0;

            card.style.display = isVisible ? '' : 'none';
        });

        updateCount(visibleCount, countedCards);
    }

    let timeout;

    const filterCardsDelayed = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            filterCards();
        }, 100);
    };

    textFilter.addEventListener('input', filterCardsDelayed);
    selectFilters.forEach(select => {
        select.addEventListener('change', filterCardsDelayed);
    });
    checkboxFilters.forEach(checkbox => {
        checkbox.addEventListener('change', filterCardsDelayed);
    });

    containerFilters.set(container, filterCardsDelayed);
    filterCards();
};
